module.exports = __webpack_public_path__ + "static/img/img_l.3e975e6d.png";